import React from 'react'

import { withMicrocopy } from '~contexts/MicrocopyContext'

import { Link as GatsbyLink } from 'gatsby'
import { OutboundLink } from 'gatsby-plugin-gtag'

const Anchor = ({ 
  href, 
  children,
  microcopy,
  ...options
}) => {
  let Component = GatsbyLink
  let target = ''
  let rel = ''
  
  if (href.match(/^https?/) || href.match(/^mailto/) || /\.(png|jpg|jpeg|webp|gif)$/.test(href)) {
    Component = OutboundLink
    target = '_blank'
    rel = 'noopener noreferrer'
  }

  let [url, anchor] = href.split('#')
  let [scheme, path] = url.split('://')

  if (path) {
    path = path.replace(/_/g, '-') 
    anchor = anchor ? `#${anchor}` : ''

    switch (scheme) {
      case 'endpoint':
      case 'endpoints':
      case 'e':
        href = `/reference/${path}/${anchor}`
        break
      case 'resource':
      case 'resources':
      case 'r':
        href = `/reference/resources/${path}/${anchor}`
        break
      case 'guide':
      case 'guides':
      case 'g':
        href = `/guides/${path}/${anchor}`
        break
      case 'page':
      case 'pages':
      case 'p':
        href = `/${path}/${anchor}`
        break
      default:
        break
    }
  }
 
  return (
    <>
      { href.startsWith('#') ? (
        <a href={ href } {...options}>{ children }</a>
      ) : (
        <Component to={href} href={href} target={target} rel={rel} {...options}>
          { children }
        </Component>
      )}
    </>
  )
}

export default withMicrocopy(Anchor)